import {toastController} from "@ionic/vue"
async function useToastAlert(color: string, message: string) {
    const toast = await toastController.create({
      color: color,
      duration: 1000,
      message: message,
    });
    await toast.present();
  }
export default useToastAlert